// extracted by mini-css-extract-plugin
export var chipContainer = "V_c5";